// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"98846ec2","488":"b7a46366"}[chunkId] + ".chunk.js";
};